import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material"
import { MetaDrivenTable, PaginationControls, StatusChip } from "../../../shared/components"
import { formatCurrency } from "../../../shared/utils";
import { useCommercialData } from "../hooks/useCommercialData";

export const DashboardList = () => {

    const { data: commercialData, isLoading: isCommercialDataLoading, isError: isCommercialDataError, error: commercialDataError, pagination, changePage, changeRowsPerPage } = useCommercialData();

    const headers = [
        { "alias_name": "project", "label": "Project", "display_order": 1, is_show: true },
        { "alias_name": "project_reference", "label": "Project ID", "display_order": 1, is_show: false },
        { "alias_name": "budget", "label": "Budget", "display_order": 2, is_show: true },
        { "alias_name": "current_eac", "label": "EAC", "display_order": 3, is_show: true },
        { "alias_name": "variance_value", "label": "Variance", "display_order": 4, is_show: true },
        { "alias_name": "variance_percent", "label": "Variance %", "display_order": 5, is_show: true },
        { "alias_name": "rag_status", "label": "RAG", "display_order": 6, is_show: true },
    ];

    const metrics = {
        project: {
            type: 'component',
            element: ((data: { project: string, project_reference: string }) => (
                <>
                    <Typography variant="body2" color="text.primary">{data.project}</Typography>
                    <Typography variant="caption" color="text.secondary">{data.project_reference}</Typography>
                </>
            ))
        },
        budget: {
            type: 'component',
            element: ((data: { budget: number }) => (
                <>{formatCurrency(data.budget)}</>
            ))
        },
        current_eac: {
            type: 'component',
            element: ((data: { current_eac: number }) => (
                <>{formatCurrency(data.current_eac)}</>
            ))
        },
        rag_status: {
            type: 'component',
            element: ((data: { rag_status: string }) => (
                <StatusChip label={data.rag_status} color={data.rag_status === 'Green' ? 'green' : data.rag_status === 'Amber' ? 'amber' : data.rag_status === 'Red' ? 'red' : 'default'} />
            ))
        },
        variance_value: {
            type: 'component',
            element: ((data: { variance_value: string }) => (
                <Typography>{formatCurrency(Number(data.variance_value))}</Typography>
            ))
        },
        variance_percent: {
            type: 'component',
            element: ((data: { variance_percent: string }) => (
                <Typography>{data.variance_percent}%</Typography>
            ))
        }
    };

    if (isCommercialDataLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                my={5}
            >
                <CircularProgress />
            </Box>
        )
    };

    if (isCommercialDataError) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Alert
                    severity="warning"
                    sx={{
                        width: "auto",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    {commercialDataError?.message || "Something went wrong!"}
                </Alert>
            </Box>
        );
    }

    return (
        <Paper variant="outlined" sx={{ m: 2, pt: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ px: 2 }}>Top Projects by Variance</Typography>
            <MetaDrivenTable headers={headers} data={commercialData} dataMetrics={metrics} sortDisabled />
            <PaginationControls total={pagination.total} rowsPerPage={pagination.limit} currentPage={pagination.page} handlePageChange={changePage} handleRowsPerPage={changeRowsPerPage} />
        </Paper>
    );

};